/**
 * Whitelabel feature flag constants.
 *
 * Use these strings with isFeatureEnabled() to check whether
 * a specific feature is available for the current tenant.
 */
export const FEATURES = {
    VRS: 'vrs',
    VRI: 'vri',
    VOICEMAIL: 'voicemail',
    RECORDING: 'recording',
    PHONE_DIAL_OUT: 'phoneDialOut',
    VCO_VOICE_BRIDGE: 'vcoVoiceBridge',
    CERTIFIED_IP_CTS: 'certifiedIpCts',
    // Jobs buyer screen in the VRI apps (VRI Settings row). Set explicitly per
    // tenant: an unknown feature reads as on.
    JOBS_BUYER: 'jobsBuyer'
};
/**
 * App type distinguishes the mobile apps:
 *   vrs  — MalkaVRS  (phone-number VRS flow, dial pad, contacts, voicemail)
 *   vri  — MalkaVRI / MapleVRI (corporate VRI console, self-view, request interpreter)
 *   relay — Malka Relay private accessible-calling demo
 *   interpreter — Malka Terp (accept live VRS/VRI calls + freelance Jobs)
 *   terp — Malka Terp (interpreter-side: queue, incoming calls, jobs, earnings)
 */
export const APP_TYPE = {
    RELAY: 'relay',
    TERP: 'terp',
    VRS: 'vrs',
    VRI: 'vri',
    INTERPRETER: 'interpreter'
};
/**
 * Room model decides who is expected in the Jitsi room and therefore who may
 * hear the interpreter. It is deliberately separate from `appType`: MalkaVCS
 * is a VRS-shaped app (dial pad, contacts, voicemail) that nevertheless runs
 * the unified room model.
 *
 *   relay   — classic VRS. The hearing party is on a PSTN leg, never in the
 *             room, and the interpreter's voice belongs on that leg only. The
 *             Deaf client must not receive interpreter audio in the room.
 *   unified — both parties are in the room (VRI-style) and the interpreter is
 *             audible to everyone. A PSTN leg may still be added, but its
 *             absence is not an error and nothing is force-muted.
 */
export const ROOM_MODEL = {
    RELAY: 'relay',
    UNIFIED: 'unified'
};
